


























































































































































































































import { IDocType, IGuest, IInternetSccess } from "@/@types/admin/guest/user";
import { getDate, getBirthday } from "@/services/dateTime/getFullDate";
import { Component, Prop, Vue } from "vue-property-decorator";
import { auth } from "@/config/host.config";

import identity_cards from "@/config/identity/identity_cards";
import ChangeDeliteButtons from "@/components/buttons/change-delite-buttons.vue";
import GuestInternetAccess from "./guest-internet-access.vue";
import StandartModal from "@/components/app/standart-modal.vue";

@Component({
  components: {
    StandartModal,
    btns: ChangeDeliteButtons,
    GuestInternetAccess,
  },
})
export default class FullGuestCard extends Vue {
  @Prop({ type: Object, default: null }) guest!: IGuest;

  spinner = false;

  get login(): string {
    if (
      !this.guest?.stay_data?.room.number ||
      !this.guest?.personal_data?.documents?.number
    )
      return "";
    return (
      this.guest.stay_data.room.number +
      "_" +
      this.guest.personal_data.documents.number.slice(-4) +
      ""
    );
  }

  get doctype(): IDocType | null {
    if (!this.guest.personal_data?.documents?.doctype) return null;
    const doc = identity_cards.find(
      (d) => d._id == this.guest.personal_data.documents.doctype
    );
    return doc ? doc : null;
  }

  get doc_number(): string {
    if (
      !this.guest.personal_data?.documents ||
      !this.guest.personal_data.documents.number
    )
      return "";
    if (
      this.guest.personal_data.documents.doctype === null ||
      this.guest.personal_data.documents.doctype === undefined
    )
      return this.guest.personal_data.documents.number;

    // Паспорт РФ
    if (this.guest.personal_data.documents.doctype == identity_cards[0]._id) {
      const length = this.guest.personal_data.documents.number.length;
      if (length > 4)
        return (
          this.guest.personal_data.documents.number.slice(0, 4) +
          " " +
          this.guest.personal_data.documents.number.slice(4)
        );
    }
    // Свидетельство о рождении
    if (this.guest.personal_data.documents.doctype == identity_cards[4]._id) {
      const str = this.guest.personal_data.documents.number;
      const index = str.search(/\d/);
      if (index != -1)
        return (
          this.guest.personal_data.documents.number.slice(0, index) +
          " " +
          this.guest.personal_data.documents.number.slice(index)
        );
    }

    return this.guest.personal_data.documents.number;
  }

  get departure(): string {
    if (!this.guest.stay_data?.departure) return "";
    return getDate(this.guest.stay_data?.departure);
  }

  get arrival(): string {
    if (!this.guest.stay_data?.arrival) return "";
    return getDate(this.guest.stay_data?.arrival);
  }

  get documents_data(): string {
    if (!this.guest.personal_data?.documents?.data) return "";
    return getDate(this.guest.personal_data?.documents?.data);
  }

  get birthday(): string {
    if (!this.guest.personal_data?.birthday) return "";
    return getBirthday(this.guest.personal_data.birthday);
  }

  async sentCode(agent: IInternetSccess): Promise<void> {
    this.spinner = true;
    const uri = auth.internet_admin;
    const data = { guest_id: this.guest._id, ip: agent.ip };
    try {
      const res = await this.$axios.post(uri, data);
      if (res.status === 200) {
        this.spinner = false;
      }
    } catch (error) {
      console.log(error);
      this.spinner = false;
    }
  }
}
